module.exports = __webpack_public_path__ + "static/media/tavatar-kay.3da7375d.png";